export const DEFAULT_COLLECTION_POSTS_COUNT = 10;

export const createCollectionSuccess = newCollection => {
  return {
    type: "CREATE_COLLECTION_SUCCESS",
    newCollection,
  };
};

export const createCollectionToAddPost = collectionName => {
  return {
    type: "CREATE_COLLECTION_TO_ADD_POST_REQUEST",
    collectionName,
  };
};

export const openNewCollectionFormModal = source => {
  return {
    type: "OPEN_NEW_COLLECTION_FORM_MODAL",
    source,
  };
};

export const openEditCollectionFormModal = () => {
  return {
    type: "OPEN_EDIT_COLLECTION_FORM_MODAL",
  };
};

export const closeCollectionFormModal = () => {
  return {
    type: "CLOSE_COLLECTION_FORM_MODAL",
  };
};

export const loadCollection = params => {
  const { collectionId, limit = DEFAULT_COLLECTION_POSTS_COUNT } = params;
  return {
    type: "LOAD_COLLECTION_REQUEST",
    collectionId,
    limit,
  };
};

export const loadCollectionSuccess = collection => ({
  type: "LOAD_COLLECTION_SUCCESS",
  collection,
});

export const loadMoreCollectionPosts = params => {
  const { collectionId, pagingToken = null, limit = DEFAULT_COLLECTION_POSTS_COUNT } = params;
  return {
    type: "LOAD_MORE_COLLECTION_POSTS_REQUEST",
    collectionId,
    pagingToken,
    limit,
  };
};

export const loadMoreCollectionPostsSuccess = ({ posts, pagingToken, limit, override }) => ({
  type: "LOAD_MORE_COLLECTION_POSTS_SUCCESS",
  posts,
  pagingToken,
  limit,
  override,
});

export const loadCollectionFailed = error => ({
  type: "LOAD_COLLECTION_FAILED",
  error,
});

export const deleteCollection = collectionId => ({
  type: "DELETE_COLLECTION_REQUEST",
  collectionId,
});

export const deleteCollectionSuccess = collectionId => ({
  type: "DELETE_COLLECTION_SUCCESS",
  collectionId,
});

export const deleteCollectionFailed = collectionId => ({
  type: "DELETE_COLLECTION_FAILED",
  collectionId,
});

export const cleanCurrentCollection = () => ({
  type: "CLEAN_CURRENT_COLLECTION",
});

export const editCollectionSuccess = collectionData => ({
  type: "EDIT_COLLECTION_SUCCESS",
  collectionData,
});

export const addPostToCollection = ({ postId, collectionId }) => ({
  type: "ADD_POST_TO_COLLECTION_REQUEST",
  postId,
  collectionId,
});

export const addPostToCollectionFailed = () => ({
  type: "ADD_POST_TO_COLLECTION_FAILED",
});

export const openAddToCollectionModal = postId => ({
  type: "OPEN_ADD_TO_COLLECTION_MODAL",
  postId,
});

export const closeAddToCollectionModal = () => ({
  type: "CLOSE_ADD_TO_COLLECTION_MODAL",
});



// WEBPACK FOOTER //
// ./src/actions/collectionActions.js